import { HeatmapWSMessageType } from '../types/websocket';
import { useWSHeatmapBase } from './useWSHeatmapBase';

export const useWSHeatmapClickedElements = () => {
  return useWSHeatmapBase({
    dataType: 'clickedElements',
    wsMessageKey: HeatmapWSMessageType.CLICKED_ELEMENTS,
    cacheSelector: (state) => state.clickedElementsCache,
    upsertSelector: (state) => state.upsertClickedElementsCache,
    emptyData: [],
  });
};
